export default {
  loading: 'Cargando precios…',
  default_modal: {
    title: 'Lista de precios predeterminada',
    description:
      'Los precios de respaldo que hereda cada socio sin configuración propia. Los cambios nunca afectan las licencias en curso.',
    saved: 'Lista de precios predeterminada guardada.',
  },
  buttons: {
    edit: 'Editar',
    cancel: 'Cancelar',
    save: 'Guardar',
  },
  toasts: {
    load_error: 'No se pudieron cargar los datos de precios.',
    save_error: 'No se pudo guardar — inténtalo de nuevo.',
    prices_saved: 'Lista de precios guardada.',
    license_created: 'Licencia creada.',
    lifecycle: {
      pause: 'Licencia pausada.',
      resume: 'Licencia reanudada.',
      cancel: 'Licencia cancelada.',
    },
  },
  price_book: {
    title: 'Lista de precios',
    read_only_notice:
      'Los precios del socio reemplazan la lista predeterminada principal. Las licencias en curso mantienen sus precios bloqueados.',
    editing_notice: 'Editando — los nuevos precios se aplican solo a las licencias creadas a partir de ahora.',
    columns: {
      service: 'Servicio',
      cost_price: 'Precio bruto ({{currency}}/mes, IVA incl.)',
    },
    add_ons: 'Complementos',
    missing_price: '{{name}} está habilitado pero no tiene precio — establece uno o desactívalo.',
    incomplete_tier:
      '{{name}} necesita tanto un precio de volumen como el número de ubicaciones activas desde el que aplica, o ninguno de los dos.',
    invalid_tier:
      'El precio de volumen de {{name}} debe ser inferior a su precio estándar, desde al menos 2 ubicaciones activas.',
    tier: {
      from: 'Precio de volumen desde',
      live_locations: 'ubicaciones activas',
      counted_one: 'Este partner cuenta con {{count}} local con licencia activa para el precio por volumen.',
      counted_other: 'Este partner cuenta {{count}} ubicaciones licenciadas activas para el precio de volumen.',
    },
    snapshot_note:
      'Los precios se fijan en una licencia al crearla — editar la lista nunca cambia las licencias en curso.',
    types: {
      base: 'Base',
      add_on: 'Complemento',
    },
  },
  volume_discount: {
    title: 'Descuento por volumen',
    read_only_notice:
      'Cuando una factura mensual alcanza el umbral de licencias, el descuento se aplica a todas las cuotas de licencia de ese ciclo.',
    editing_notice: 'Editando — los nuevos valores se aplican desde el próximo ciclo de facturación.',
    threshold_label: 'Umbral de licencias',
    percent_label: 'Descuento',
    invalid: 'Introduce un umbral de al menos 1 y un descuento entre 0 y 100%.',
    saved: 'Descuento por volumen guardado.',
    note: 'Cuenta las licencias facturadas en el propio ciclo; los meses arrastrados quedan excluidos. 0 % (el valor por defecto) desactiva el descuento; de lo contrario se sumaría al precio por volumen de la lista de precios.',
  },
  licenses: {
    test_restaurant_unlicensable: 'Un restaurante de prueba nunca se factura, por lo que no puede tener una licencia.',
    title: 'Licencias de restaurante',
    select_company: 'Seleccionar un restaurante',
    add_license: 'Añadir licencia',
    no_companies: 'Este socio aún no tiene restaurantes.',
    no_licenses: 'Aún no hay licencias para este restaurante.',
    activated_at: 'Activo desde',
    next_period_preview: 'Próximo mes (prorrateado, antes del descuento por volumen)',
    statuses: {
      active: 'Activo',
      paused: 'Pausado',
      canceled: 'Cancelado',
    },
    columns: {
      product: 'Servicio',
      locked_price: 'Precio bloqueado / mes',
      quantity: 'Cant.',
      trial_ends: 'Gratis hasta',
    },
    price_tiers: {
      volume: 'Tarifa por volumen',
      locked: 'Precio heredado',
    },
  },
  lifecycle: {
    pause: {
      action: 'Pausar',
      title: '¿Pausar esta licencia?',
      description:
        'Los días pausados no se facturan. La licencia mantiene sus precios bloqueados y puede reanudarse en cualquier momento.',
      confirm: 'Pausar',
    },
    resume: {
      action: 'Reanudar',
      title: '¿Reanudar esta licencia?',
      description: 'La facturación continúa desde hoy a los precios bloqueados.',
      confirm: 'Reanudar',
    },
    cancel: {
      action: 'Cancelar licencia',
      title: '¿Cancelar esta licencia?',
      description:
        'El mes actual se factura a prorrata hasta hoy. Esto no se puede deshacer — se crearía una nueva licencia con los precios actuales de la lista.',
      confirm: 'Cancelar licencia',
    },
  },
  add_license: {
    title: 'Añadir una licencia',
    description: 'Selecciona los servicios para este restaurante. Los precios se fijan en la licencia al crearla.',
    per_month: ' / mes',
    create: 'Crear licencia',
    no_priced_products:
      'Ningún producto tiene un precio utilizable para este socio todavía — establezca primero la lista de precios.',
  },
};
